// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* WellSky Brand Colors */
:root {
  /* Primary Colors */
  --wellsky-indigo: #253746;
  --wellsky-blue: #71B0B4;
  --wellsky-white: #FFFFFF;
  --wellsky-ocher: #D38235;
  --wellsky-sand: #D6D2C4;
  --wellsky-sand-tint: #EFF0EA;

  /* Usage Mappings */
  --color-primary-text: var(--wellsky-indigo);
  --color-primary-dark-bg: var(--wellsky-indigo);
  --color-primary-bg: var(--wellsky-white);

  --color-card-header: var(--wellsky-blue);
  --color-links: var(--wellsky-blue);
  --color-primary-button: var(--wellsky-blue);

  --color-secondary-button: var(--wellsky-ocher);
  --color-accent: var(--wellsky-ocher);

  --color-alt-bg: var(--wellsky-sand);
  --color-light-bg: var(--wellsky-sand-tint);

  /* Status Colors (keeping existing for consistency) */
  --color-success: #28a745;
  --color-warning: #ffc107;
  --color-error: #dc3545;
  --color-info: var(--wellsky-blue);
  --color-neutral: #6c757d;

  /* Severity palette (Errors tab) — reuse status tokens where they match */
  --color-severity-critical: var(--color-error);
  --color-severity-high: #fd7e14;
  --color-severity-medium: var(--color-warning);
  --color-severity-low: var(--color-success);

  /* Outreach category palette (Outreach Search tab) */
  --color-category-outgoing: #1976d2;
  --color-category-incoming: #43a047;
  --color-category-voicemail: #f57c00;
  --color-category-ivr: #7b1fa2;

  /* Outreach type palette (Outreach Search tab) */
  --color-type-phone: #1976d2;
  --color-type-email: #00897b;
  --color-type-text: #5e35b1;
  --color-type-push: #c2185b;

  /* UI Element Colors */
  --color-border: #ddd;
  --color-shadow: rgba(37, 55, 70, 0.1);
  --color-hover-shadow: rgba(37, 55, 70, 0.15);
}
`, "",{"version":3,"sources":["webpack://./src/styles/colors.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,4BAA4B;;EAE5B,mBAAmB;EACnB,2CAA2C;EAC3C,8CAA8C;EAC9C,wCAAwC;;EAExC,wCAAwC;EACxC,kCAAkC;EAClC,2CAA2C;;EAE3C,8CAA8C;EAC9C,oCAAoC;;EAEpC,mCAAmC;EACnC,0CAA0C;;EAE1C,qDAAqD;EACrD,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,iCAAiC;EACjC,wBAAwB;;EAExB,yEAAyE;EACzE,6CAA6C;EAC7C,8BAA8B;EAC9B,6CAA6C;EAC7C,0CAA0C;;EAE1C,oDAAoD;EACpD,kCAAkC;EAClC,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;;EAE7B,gDAAgD;EAChD,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;EAC1B,0BAA0B;;EAE1B,sBAAsB;EACtB,oBAAoB;EACpB,qCAAqC;EACrC,4CAA4C;AAC9C","sourcesContent":["/* WellSky Brand Colors */\n:root {\n  /* Primary Colors */\n  --wellsky-indigo: #253746;\n  --wellsky-blue: #71B0B4;\n  --wellsky-white: #FFFFFF;\n  --wellsky-ocher: #D38235;\n  --wellsky-sand: #D6D2C4;\n  --wellsky-sand-tint: #EFF0EA;\n\n  /* Usage Mappings */\n  --color-primary-text: var(--wellsky-indigo);\n  --color-primary-dark-bg: var(--wellsky-indigo);\n  --color-primary-bg: var(--wellsky-white);\n\n  --color-card-header: var(--wellsky-blue);\n  --color-links: var(--wellsky-blue);\n  --color-primary-button: var(--wellsky-blue);\n\n  --color-secondary-button: var(--wellsky-ocher);\n  --color-accent: var(--wellsky-ocher);\n\n  --color-alt-bg: var(--wellsky-sand);\n  --color-light-bg: var(--wellsky-sand-tint);\n\n  /* Status Colors (keeping existing for consistency) */\n  --color-success: #28a745;\n  --color-warning: #ffc107;\n  --color-error: #dc3545;\n  --color-info: var(--wellsky-blue);\n  --color-neutral: #6c757d;\n\n  /* Severity palette (Errors tab) — reuse status tokens where they match */\n  --color-severity-critical: var(--color-error);\n  --color-severity-high: #fd7e14;\n  --color-severity-medium: var(--color-warning);\n  --color-severity-low: var(--color-success);\n\n  /* Outreach category palette (Outreach Search tab) */\n  --color-category-outgoing: #1976d2;\n  --color-category-incoming: #43a047;\n  --color-category-voicemail: #f57c00;\n  --color-category-ivr: #7b1fa2;\n\n  /* Outreach type palette (Outreach Search tab) */\n  --color-type-phone: #1976d2;\n  --color-type-email: #00897b;\n  --color-type-text: #5e35b1;\n  --color-type-push: #c2185b;\n\n  /* UI Element Colors */\n  --color-border: #ddd;\n  --color-shadow: rgba(37, 55, 70, 0.1);\n  --color-hover-shadow: rgba(37, 55, 70, 0.15);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
